import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-1 text-sm text-foreground-500">关于星星动漫网的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}